import { render, staticRenderFns } from "./CouponApplyDateComponent.vue?vue&type=template&id=88e8db44&scoped=true&"
import script from "./CouponApplyDateComponent.vue?vue&type=script&lang=ts&"
export * from "./CouponApplyDateComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CouponApplyDateComponent.vue?vue&type=style&index=0&id=88e8db44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e8db44",
  null
  
)

export default component.exports